import { render, staticRenderFns } from "./InlineRatingSection.vue?vue&type=template&id=38c69e33&scoped=true&"
import script from "./InlineRatingSection.vue?vue&type=script&lang=js&"
export * from "./InlineRatingSection.vue?vue&type=script&lang=js&"
import style0 from "./InlineRatingSection.vue?vue&type=style&index=0&id=38c69e33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c69e33",
  null
  
)

export default component.exports